
    <input type="checkbox" [ngModel]="isAllSelected">
  